// Usuários de credor (access_type = 'creditor') não podem executar escritas nas telas de credor: o backend responde 403
export const isUsuarioCredor = () => localStorage.getItem('accessType') === 'creditor'

export default isUsuarioCredor
